import enElement from 'element-ui/lib/locale/lang/en';
import en from '../../../lang/en.json';

export const defaultLocale = 'en';

export const languages = {
    en: {
        ...en,
        ...enElement,
        color: '0 {0}colors | {n} {0}color | {n} {0}colors',
        item: '0 items | {n} item | {n} items',
    },
};
